import {
  types,
  IGetGroupsDetailedAction,
  IGetGroupsDetailedSuccessAction,
  IFailureAction,
  IUpdateGroupsDetailedAction,
} from '../types/groupsDetailed'
import { IGroupDetailed } from '../types/group'

export const getGroupsDetailed = (): IGetGroupsDetailedAction => ({
  type: types.GET_GROUPS_DETAILED__STARTED,
})

export const getGroupsDetailedSuccess = (
  list: IGroupDetailed[]
): IGetGroupsDetailedSuccessAction => ({
  type: types.GET_GROUPS_DETAILED__SUCCESS,
  list,
})

export const getGroupsDetailedFailure = (message: string): IFailureAction => ({
  type: types.GET_GROUPS_DETAILED__FAILURE,
  message,
})

export const updateGroupsDetailed = (
  list: IGroupDetailed[]
): IUpdateGroupsDetailedAction => ({
  type: types.UPDATE_GROUPS_DETAILED,
  list,
})
